export default __webpack_public_path__ + "static/media/signup.dd082c99.svg";